import { exists } from '@/api'

export interface ReservationCandidateList {
  id: number
  name: string
  nameKana: string
  revision: number
}

export function ReservationCandidateListFromJSON(
  json: any
): ReservationCandidateList {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
